import { render, staticRenderFns } from "./reflectRecord.vue?vue&type=template&id=d2a3df98&scoped=true"
import script from "./reflectRecord.vue?vue&type=script&lang=js"
export * from "./reflectRecord.vue?vue&type=script&lang=js"
import style0 from "./reflectRecord.vue?vue&type=style&index=0&id=d2a3df98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a3df98",
  null
  
)

export default component.exports